// src/components/PostButton.jsx
import { useState } from "react";
import { postToEtsy, postToEbay } from "../lib/api";

const PLATFORMS = {
  etsy: { name: "Etsy",  color: "#F1641E", fn: postToEtsy },
  ebay: { name: "eBay",  color: "#0064D2", fn: postToEbay },
};

export default function PostButton({ platformKey, listing, connectionStatus, label, onPosted }) {
  const [state, setState] = useState("idle");
  const [result, setResult] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const p = PLATFORMS[platformKey];
  if (!p) return null;

  const connected = connectionStatus?.[platformKey];
  if (!connected) return null;

  const post = async () => {
    setState("posting");
    setErrorMsg("");
    try {
      const tags = (listing.hashtags || "")
        .split(" ")
        .map(t => t.replace(/^#/, "").trim())
        .filter(Boolean);

      const payload = {
        title: listing.suggestedTitle,
        description: listing.suggestedDescription,
        price: listing.suggestedPrice,
        suggestedPrice: listing.suggestedPrice,
        imageUrls: listing.imageUrls || [],
        tags,
        condition: listing.condition,
        category: listing.category,
        gender: listing.gender,
        size: listing.size,
        brand: listing.brand,
        material: listing.material,
        color: listing.color,
        era: listing.era,
      };

      const res = await p.fn(payload);
      if (res.success) {
        setResult(res);
        setState("success");
        if (onPosted) onPosted(platformKey, res);
      } else {
        setErrorMsg(res.error || "Something went wrong");
        setState("error");
      }
    } catch (e) {
      setErrorMsg(e.message || "Network error");
      setState("error");
    }
  };

  if (state === "success" && result) {
    return (
      <a className="post-btn success" href={result.listingUrl} target="_blank" rel="noopener noreferrer" style={{ borderColor: p.color, color: p.color }}>
        ✓ Live on {p.name} →
      </a>
    );
  }

  if (state === "error") {
    return (
      <div className="post-error">
        <span>⚠ {errorMsg}</span>
        <button className="post-btn retry" onClick={post}>Retry</button>
      </div>
    );
  }

  return (
    <button
      className={`post-btn ${state === "posting" ? "posting" : ""}`}
      style={{ borderColor: state === "idle" ? p.color : undefined, color: state === "idle" ? p.color : undefined }}
      onClick={post}
      disabled={state === "posting"}
    >
      {state === "posting"
        ? `Posting to ${p.name}…`
        : label || `Post to ${p.name} →`}
    </button>
  );
}
